import React from 'react';

import { VpUpgradePromptBox } from '@vp-ui/components/VpUpgradePromptBox';

export const InsightsUpgradePrompt = () => (
  <VpUpgradePromptBox
    title="Upgrade to unlock AI Insights"
    description="AI Insights scores every video response against your chosen templates. Available on Premium and Enterprise plans."
  />
);

export default InsightsUpgradePrompt;



// WEBPACK FOOTER //
// ./src/vp-ui/components/InsightsUpgradePrompt/InsightsUpgradePrompt.jsx